// A2-638 — boxes the page folds into one line (boxView.boxPlace decides
// which): the ones at 0 this period, and the app's own workings that are not
// on the form. The line names every box, so nothing is hidden without being
// listed; opening it shows the full cards. The cards are only drawn when
// open, so "go to box" opens the fold first (CountryReturn.revealBox).
import React from "react";
import { useTranslation } from "react-i18next";
import { boxName } from "./boxView";

export const SharedNote = ({ note }) => (
  <div data-testid="shared-note" className="text-xs text-slate-600 dark:text-slate-300 leading-snug">
    <span className="font-semibold">{note.boxes.map(boxName).join(", ")}:</span>{" "}{note.text}
  </div>
);

export const FoldedBoxes = ({ kind, boxes, open, onToggle, notes = [], renderBox }) => {
  const { t } = useTranslation();
  if (!boxes.length) return null;
  const title = {
    unused: t("ui.country_return.fold.unused", { defaultValue: "0 on the form this period" }),
    stub: t("ui.country_return.fold.stub", { defaultValue: "Not worked out by the app — fill in on the form yourself if you have this activity" }),
    working: t("ui.country_return.fold.working", { defaultValue: "Workings, not on the form" }),
    optional: t("ui.country_return.fold.optional", { defaultValue: "Adjustments, only if they apply" }),
  }[kind];
  return (
    <section data-testid={`fold-${kind}`} className="mb-6">
      <button
        type="button"
        data-testid={`fold-${kind}-toggle`}
        aria-expanded={open ? "true" : "false"}
        aria-controls={`fold-${kind}-cards`}
        onClick={onToggle}
        className="w-full text-left text-sm rounded-lg border border-slate-200 dark:border-slate-700 surface-panel px-3 py-2 hover:border-slate-400 dark:hover:border-slate-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-teal-600"
      >
        <span className="font-semibold text-teal-700 dark:text-teal-300">
          <span aria-hidden="true">{open ? "▾" : "▸"}</span> {title} ({boxes.length})
        </span>
        <span data-testid={`fold-${kind}-names`} className="block text-xs text-slate-600 dark:text-slate-300 mt-0.5">
          {boxes.map(boxName).join(", ")}
        </span>
      </button>
      {open && (
        <div id={`fold-${kind}-cards`} className="mt-3">
          {notes.length > 0 && (
            <div className="mb-3 space-y-1">{notes.map((n) => <SharedNote key={n.text} note={n} />)}</div>
          )}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{boxes.map(renderBox)}</div>
        </div>
      )}
    </section>
  );
};
